export default "__VITE_ASSET__DEX9IzT1__"